<template>
  <div id="buyItems">
    <img
      v-if="checkoutNotice.url"
      :src="$baseImgUrl + checkoutNotice.url"
      :alt="checkoutNotice.content"
      width="100%"
      style="margin-top: 2.55rem"
    />
    <div class="nr step1">
      <div class="center">
        <div class="tit">
          <h2>結帳優惠</h2>
        </div>
        <CompMarquee />
        <CbuyHeader :now-page="nowPage"></CbuyHeader>
        <div class="ctnr">
          <h3>購買項目</h3>
          <div class="blk">
            <span>發票載具</span>
            <input type="text" v-model="vehicle" value="" placeholder="" />
          </div>
          <ul>
            <li v-for="(item, index) in rechargeMethodsList" :key="index">
              <div class="p1">
                <div class="l">
                  <strong>{{ item.sort }}</strong>
                  <span>{{ item.name }}</span>
                </div>
              </div>
              <div class="p2">
                <strong>${{ item.money | cleanDotFilter }}</strong>
                <span
                  >購買點數: {{ item.correct_quantity | cleanDotFilter }}</span
                >
              </div>
              <div class="p3">
                <p v-if="item.gift_quantity != 0">
                  贈送:{{ item.gift_currency | coinName }}
                  {{ item.gift_quantity | cleanDotFilter }} 點
                </p>
                <p v-if="item.gift_quantity == 0">無</p>
                <router-link
                  class="buy"
                  style="cursor: pointer"
                  :to="{
                    name: 'cbuydet',
                    params: {
                      id: item.id,
                      paytype: item.paytype,
                      vehicle: vehicle === '' ? null : vehicle,
                    },
                  }"
                ></router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <CompFoot />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {
    CompMarquee: require("@/components/parts/Marquee").default,
    CbuyHeader: require("@/components/parts/cbuyHeader").default,
    CompFoot: require("@/components/parts/Foot").default,
  },
  computed: {
    ...mapState({
      rechargeMethodsList: (state) => state.recharge.rechargeMethodsList,
      checkoutNotice: (state) => state.precautions.checkoutNotice,
    }),
  },
  data() {
    return {
      vehicle: "",
      nowPage: "",
    };
  },
  methods: {
    async getRechargeMethods() {
      await this.$store.dispatch("recharge/getRechargeMethods");
    },
    async getCheckoutNoticeList() {
      await this.$store.dispatch("precautions/getCheckoutNoticeList");
    },
  },
  mounted() {
    this.getRechargeMethods();
    this.getCheckoutNoticeList();
    this.nowPage = this.$route.name;
  },
};
</script>
<style>
@import "~@/assets/css/cbuy.css";
#buyItems .nr.step1 {
  padding-top: 0 !important;
}
.blk {
  width: 100%;
  overflow: hidden;
  margin-top: 22px;
}
.blk span {
  display: block;
  width: 30%;
  text-align: left;
  line-height: 0.6rem;
  float: left;
  font-size: 0.34rem;
  padding-left: 0.1rem;
}
.blk input[type="text"] {
  width: 70%;
  line-height: 0.6rem;
  float: left;
  display: block;
  background: #545253;
  border: none;
  padding-left: 0.2rem;
  color: #deddde;
  font-size: 0.34rem;
}
</style>
